import { Component, OnInit } from '@angular/core';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { Constants } from 'src/app/_consts/constants';

@Component({
  selector: 'app-log-modal',
  templateUrl: './log-modal.component.html',
  styleUrls: ['./log-modal.component.scss']
})
export class LogModalComponent implements OnInit {

  cols = Constants.LOG_COLS
  refreshUrl = "getLogs"
  params: any

  constructor(private modal: NgxSmartModalComponent) {
    const data = this.modal.getData()
    this.params = {
      table: data?.table,
      id_primary: data?.id_primary
    }
    if(data.hideOldVal){
      this.cols = this.cols.filter(c => c.attr !== 'old_val')
    }
  }

  ngOnInit(): void {
  }

  onRowsRaw(rows) {
    let lastRow
    rows.forEach(r => {
      r.new_val = JSON.parse(r.json);
      r.old_val = lastRow || {}
      if(r.new_val?.old_val && r.new_val?.new_val){
        r.old_val = r.new_val.old_val
        r.new_val = r.new_val.new_val
      }
      lastRow = r.new_val
    });

    // const current = this.modal.getData()?.current
    // if(lastRow && current){
    //   rows.push({action:test})
    // }
  }
}
